import { render, staticRenderFns } from "./testimonial-row.vue?vue&type=template&id=7f3ca873&scoped=true&"
import script from "./testimonial-row.vue?vue&type=script&lang=js&"
export * from "./testimonial-row.vue?vue&type=script&lang=js&"
import style0 from "./testimonial-row.vue?vue&type=style&index=0&id=7f3ca873&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3ca873",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f3ca873')) {
      api.createRecord('7f3ca873', component.options)
    } else {
      api.reload('7f3ca873', component.options)
    }
    module.hot.accept("./testimonial-row.vue?vue&type=template&id=7f3ca873&scoped=true&", function () {
      api.rerender('7f3ca873', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/pageParts/testimonial-row.vue"
export default component.exports